var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('li',{staticClass:"tw-w-full tw-px-4 tw-py-3 tw-border-gray-200 tw-rounded-t-lg",class:{ 'tw-border-b': _vm.showBottomBorder }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }